export { default as getMailAnalyticOptions } from './getMailAnalyticOptions';
//# sourceMappingURL=index.js.map